module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/tv/tv.mtl";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/tv/tv.mtl
// module id = 645
// module chunks = 0